export var RulebookSelectionSort;
(function (RulebookSelectionSort) {
    RulebookSelectionSort["Latest"] = "latest";
    RulebookSelectionSort["Oldest"] = "oldest";
})(RulebookSelectionSort || (RulebookSelectionSort = {}));
/** Newest first (or oldest first) by creation time, falling back to the last update. */
export function sortRulebooks({ rulebooks, sort }) {
    const timeOf = (rulebook) => rulebook.createdAt ?? rulebook.updatedAt ?? 0;
    const direction = sort === RulebookSelectionSort.Latest ? -1 : 1;
    return [...rulebooks].sort((first, second) => direction * (timeOf(first) - timeOf(second)));
}
/**
 * Case-insensitive match on name, description and tags. The picked Rulebook (`keepId`) always stays listed so the
 * selection never disappears while typing.
 */
export function filterRulebooksBySearch({ rulebooks, query, keepId, }) {
    const needle = query.trim().toLowerCase();
    if (!needle) {
        return rulebooks;
    }
    return rulebooks.filter((rulebook) => rulebook.id === keepId ||
        rulebook.name.toLowerCase().includes(needle) ||
        (rulebook.description ?? "").toLowerCase().includes(needle) ||
        rulebook.tags.some((tag) => tag.toLowerCase().includes(needle)));
}
